var TECL_FormValidation = {

   Initialise: function() {
      $(document).ready(function() {

         var focusedOnBadInput = false;

         $(".select-all").on("click", function(event) {
            event.preventDefault();
            $(this).parent().find("input:checkbox").prop('checked', true);
         });

         $( ".enquiry-form" ).submit(function( event ) {
            $(":input[type='text'][required],:input[type='email'][required],:input[type='number'][required],select[required]").each(function(){

               var element = $(this);
               var value = $(this).val() || "";

               if(element.hasClass("tagsInput")) {
                  element = element.parent();
               }

               if(value.length === 0) {
                  if(element.next().hasClass("text-danger")) {
                     element.next(".text-danger").text("You must fill in this field.");
                  } else {
                     element.after('<div class="alert text-danger" role="alert">You must fill in this field.</div>');
                  }

                  if(!focusedOnBadInput) {

                     $('html, body').animate({
                        scrollTop: $(this).offset().top - 200 /* 80 is height of navbar + input label */
                     }, 800);
                     $(this).focus();
                     focusedOnBadInput = true;
                  }
                  element.addClass("has-error");
                  event.preventDefault();
               } else {
                  if(element.next().hasClass("text-danger")) {
                     element.next().remove();
                     element.removeClass("has-error");
                  }
               }
            });

            $('div.checkbox-group.required').each(function(){
               if($(this).find("input[type='checkbox']:checked").length == 0) {
                  if($(this).children(".alert").length > 0) {
                     $(this).children(".alert").text("You must tick at least one box in this group.");
                  } else {
                     $(this).append('<div class="alert text-danger" role="alert">You must tick at least one box in this group.</div>');
                  }
                  $(this).addClass("has-error");
                  if(!focusedOnBadInput) {
                     $('html, body').animate({
                        scrollTop: $(this).offset().top - 200 /* 80 is height of navbar + input label */
                     }, 800);
                     $(this).focus();
                     focusedOnBadInput = true;
                  }
                  event.preventDefault();
               } else {
                  $(this).children(".alert").remove();
                  $(this).removeClass("has-error");
               }
            });

            var manualSchoolName = $("input[name='orgName']").val() || "";
            var schoolSearch = $("#schoolSearch").attr("data_id") || "";

            if( manualSchoolName.length == 0 && schoolSearch.length == 0) {
              event.preventDefault();
              if(!$(".g-recaptcha").next().hasClass("text-danger")) {
                 $(".g-recaptcha").after('<div class="alert text-danger" role="alert">' +
                    'Please select your school using the school search above by clicking ' +
                    'on the name of your school from the results, ' +
                    'or fill in your school details manually by clicking the ' +
                    '"I can\'t find my school" link above.</div>');
              }
            } else {
              if($(".g-recaptcha").next().hasClass("text-danger")) {
                $(".g-recaptcha").next().remove();
              }
            }

            if(grecaptcha.getResponse().length == 0){
               event.preventDefault();
               if(!$(".g-recaptcha").next().hasClass("text-danger")) {
                  $(".g-recaptcha").after('<div class="alert text-danger" role="alert">You must complete the reCAPTCHA above.</div>');
               }
            }

            focusedOnBadInput = false;
         });
      });
   }
}
TECL_FormValidation.Initialise();
